import React from 'react';

import { ContentNotAvailable } from '../../../../components/shared/ContentNotAvailable';
import { useNetwork } from '../../../../hooks/useNetwork';
import { YouTubeVideoPlayer } from '@ael/shared-components-library';

import './embedded-video-viewer.scss';

type EmbeddedVideoViewerProps = {
  embedCode: string;
  onEnded?: () => void;
};

export const EmbeddedVideoViewer: React.FC<EmbeddedVideoViewerProps> = (props) => {
  const isOnline = useNetwork();

  if (!isOnline) {
    return <ContentNotAvailable />;
  }

  // Try to extract YouTube video ID from embed code
  const videoIdMatch = props.embedCode.match(/(?:youtube\.com\/embed\/)([^"&?\s]+)/);
  const youtubeVideoId = videoIdMatch ? videoIdMatch[1] : null;

  // If it's a YouTube video and we have an onEnded handler, use the YouTube player
  if (youtubeVideoId) {
    return <YouTubeVideoPlayer videoId={youtubeVideoId} onEnded={props.onEnded} />;
  }

  // Fallback to standard iframe embed
  return <div className="embedded-video-viewer" dangerouslySetInnerHTML={{ __html: props.embedCode }} />;
};
